module.exports = __webpack_public_path__ + "img/login-technician.5bde58fe.png";